import { LazyMotion, MotionConfig, domAnimation } from 'motion/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { SessionProvider } from './shared/session/SessionContext';
// Las declaraciones de fuente van primero: si llegan después de las reglas que las usan, el
// navegador pinta el primer cuadro con la de respaldo y lo cambia enseguida.
import './shared/styles/fonts.css';
import './shared/styles/base.css';
import './shared/styles/components.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Falta el nodo #root en index.html.');
}

/*
 * `LazyMotion` con `domAnimation`, y `m` en vez de `motion`.
 *
 * `domAnimation` es el subconjunto de animaciones y gestos del DOM: deja afuera `layout` y las
 * transformaciones de SVG, que este producto no usa. `strict` lo hace cumplir — con él, escribir
 * `motion.div` en lugar de `m.div` falla en tiempo de ejecución en vez de volver a meter la
 * librería entera sin que nadie lo note.
 *
 * Se probó cargarlo en diferido con `features={() => import('motion/react')}` y sale peor: `m` y
 * `AnimatePresence` ya importan ese módulo de forma estática, así que Vite no puede separarlo y
 * termina con el paquete inicial más grande, no más chico. Medido: 130 kB comprimidos contra 167.
 */
createRoot(container).render(
  <StrictMode>
    <LazyMotion features={domAnimation} strict>
      {/*
        El media query de tokens.css apaga las animaciones de CSS, pero Motion anima estilos en
        línea por JavaScript y no lo lee. Sin esto, quien pidió menos movimiento en su sistema
        operativo lo conseguía en todas partes menos acá.
      */}
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
        </BrowserRouter>
      </MotionConfig>
    </LazyMotion>
  </StrictMode>,
);

/*
 * RF-49 · el service worker sirve el caparazón sin conexión. Se registra después de `load` para
 * no competir por ancho de banda con la primera pantalla, que es lo que la persona está mirando.
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}
